module.exports = __webpack_public_path__ + "static/img/brain_games.7b71746.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/brain_games.png
// module id = OOHd
// module chunks = 1